import { Withdrawals } from './Withdrawals';

export default Withdrawals;
